import axios from 'axios'

/*
let appConfig = { 
  http_base_url:'',
  http_control_base_url: 'http://localhost:64703/' 
};

fetch('/static/config.json')
  .then(res => res.json())
  .then(config => { appConfig = config; })
  .catch(() => {});
*/

export const HTTP = axios.create({
  baseURL: '', 
})

export const HTTP_CONTROL = axios.create({
//  baseURL: appConfig.http_control_base_url,
  baseURL: '', 
})

const dashboardUrls = [
  '/api/get-summary',
  '/api/daily-flights',
  '/api/daily-payload',
  '/api/get-incomes',
  '/api/arrival-board',
  '/api/departure-board',
  '/api/boards',
  '/api/direction-statistic',
  '/api/perron-map',
]

const dashboardRetryDelay = config => {
  let urlIndex = dashboardUrls.indexOf(config.url)
  return 1000 + Math.max(0, urlIndex) * 200
}

let dashboardCancelSource = null
let controlsCancelSource = null

HTTP.interceptors.request.use(config => {
  if (dashboardCancelSource && dashboardUrls.indexOf(config.url) !== -1) {
    config.cancelToken = dashboardCancelSource.token
  }
  return config
})

HTTP.interceptors.response.use(
  response => response,
  error => {
    let config = error.config
    let isDashboardRequest = config && dashboardUrls.indexOf(config.url) !== -1
    let shouldRetry = isDashboardRequest &&
      config.url !== '/api/v1/arc' &&
      error.response &&
      error.response.status === 500 &&
      !config.dashboardRetryCompleted

    if (!shouldRetry) {
      return Promise.reject(error)
    }

    config.dashboardRetryCompleted = true

    return new Promise((resolve, reject) => {
      let timeout = setTimeout(resolve, dashboardRetryDelay(config))

      if (config.cancelToken) {
        config.cancelToken.promise.then(cancel => {
          clearTimeout(timeout)
          reject(cancel)
        })
      }
    }).then(() => HTTP.request(config))
  }
)

HTTP_CONTROL.interceptors.request.use(config => {
  if (controlsCancelSource && config.url === '/api/v1/arc') {
    config.cancelToken = controlsCancelSource.token
  }
  return config
})

export function beginDashboardUpdate() {
  if (dashboardCancelSource) {
    dashboardCancelSource.cancel('Dashboard update replaced')
  }
  dashboardCancelSource = axios.CancelToken.source()
  return dashboardCancelSource
}

export function finishDashboardUpdate(source) {
  if (dashboardCancelSource === source) {
    dashboardCancelSource = null
  }
}

export function beginControlsUpdate() {
  if (controlsCancelSource) {
    controlsCancelSource.cancel('Controls update replaced')
  }
  controlsCancelSource = axios.CancelToken.source()
  return controlsCancelSource
}

export function cancelControlsUpdate() {
  if (controlsCancelSource) {
    controlsCancelSource.cancel('Dashboard update replaced')
    controlsCancelSource = null
  }
}

export function finishControlsUpdate(source) {
  if (controlsCancelSource === source) {
    controlsCancelSource = null
    return true
  }
  return false
}

export function isCanceledRequest(error) {
  return axios.isCancel(error)
}
